import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Website = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M9 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m2.199 10.502H6.8C7.244 14.089 8.115 15.5 9 15.5s1.756-1.411 2.199-3.498M5.777 12H3.233a6.52 6.52 0 0 0 3.736 3.176c-.531-.79-.942-1.89-1.192-3.176m8.99 0h-2.544c-.25 1.285-.661 2.386-1.192 3.177A6.53 6.53 0 0 0 14.767 12M5.62 7H2.813A6.5 6.5 0 0 0 2.5 9c0 .698.11 1.37.314 2l2.805.001C5.541 10.363 5.5 9.691 5.5 9s.041-1.362.119-2m5.751 0H6.63c-.084.63-.13 1.3-.13 2s.046 1.372.13 2h4.74c.084-.628.13-1.3.13-2s-.046-1.37-.13-2m3.817 0H12.38c.078.638.119 1.309.119 2s-.041 1.363-.12 2.001h2.806c.204-.63.314-1.303.314-2.001s-.11-1.37-.313-2M6.969 2.823l-.19.068A6.52 6.52 0 0 0 3.231 6h2.544c.25-1.286.662-2.386 1.193-3.178M9 2.5l-.1.006c-.85.101-1.673 1.484-2.099 3.493H11.2C10.756 3.912 9.885 2.5 9 2.5m2.03.323.028.04c.518.788.92 1.873 1.166 3.137h2.544a6.52 6.52 0 0 0-3.737-3.177"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Website$1 = Svg18Website;

export { Svg18Website$1 as default };
